import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class WelcomeMigratedUserConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getShowWelcomePage(): boolean {
		return this.configService.get((x) => x.matCommonUi.profileCompleteness?.showWelcomePage, true);
	}
}
